export const Comparisons = {
  milestones: [
    { threshold: 15, text: "a large pizza", icon: "🍕" },
    { threshold: 30, text: "a tank of gas", icon: "⛽" },
    { threshold: 50, text: "a Netflix subscription", icon: "📺" },
    { threshold: 100, text: "groceries for a week", icon: "🛒" },
    { threshold: 150, text: "a nice dinner for two", icon: "🍽️" },
    { threshold: 200, text: "concert tickets", icon: "🎵" },
    { threshold: 300, text: "AirPods Pro", icon: "🎧" },
    { threshold: 400, text: "a Nintendo Switch", icon: "🎮" },
    { threshold: 500, text: "a fancy office chair", icon: "💺" },
    { threshold: 700, text: "an iPad", icon: "📱" },
    { threshold: 1000, text: "a MacBook Air", icon: "💻" },
    { threshold: 1500, text: "a premium laptop", icon: "💻" },
    { threshold: 2000, text: "a month's rent", icon: "🏠" },
    { threshold: 3000, text: "a semester of college tuition", icon: "🎓" },
    { threshold: 5000, text: "a used car down payment", icon: "🚗" },
    { threshold: 10000, text: "a luxury vacation", icon: "✈️" }
  ],

  getComparison(cost) {
    const milestone = [...this.milestones].reverse().find(m => cost >= m.threshold);
    if (milestone) return `${milestone.icon} That's enough to buy ${milestone.text}!`;
    return null;
  },
  
  getVisualComparisons(cost) {
    const items = [
      { name: 'Coffee', icon: '☕', unitCost: 5, unit: 'cups' },
      { name: 'Pizza', icon: '🍕', unitCost: 12, unit: 'pizzas' },
      { name: 'Online Course', icon: '🎓', unitCost: 100, unit: 'courses' },
      { name: 'Software License', icon: '⚙️', unitCost: 200, unit: 'licenses' },
      { name: 'Laptop', icon: '💻', unitCost: 800, unit: 'laptops' },
      { name: 'Conference Ticket', icon: '🎟️', unitCost: 1000, unit: 'tickets' }
    ];
    
    return items.map(item => ({
      ...item,
      count: Math.floor(cost / item.unitCost)
    })).filter(item => item.count > 0);
  }
};